(ns manage.ad-variant.widgets
  (:require ["@mui/icons-material/AccountCircleRounded$default" :as AccountCircleRoundedIcon]
            ["@mui/icons-material/CancelRounded$default" :as CancelRoundedIcon]
            ["@mui/icons-material/CheckCircleRounded$default" :as CheckCircleRoundedIcon]
            ["@mui/material/Avatar$default" :as Avatar]
            ["@mui/material/AvatarGroup$default" :as AvatarGroup]
            ["@mui/material/Badge$default" :as Badge]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/FormControl$default" :as FormControl]
            ["@mui/material/InputLabel$default" :as InputLabel]
            ["@mui/material/ListItemIcon$default" :as ListItemIcon]
            ["@mui/material/ListItemText$default" :as ListItemText]
            ["@mui/material/Menu$default" :as Menu]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Select$default" :as Select]
            ["@mui/material/Skeleton$default" :as Skeleton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["material-ui-popup-state/hooks" :as muips]
            ["src/svg/arrows/arrow-bounce-right.svg$default" :as ArrowBounceRight]
            ["src/svg/chevron/chevron-down.svg$default" :as ChevronDown]
            ["src/svg/wpp/content/calendar.svg$default" :as Calendar]
            [common.queries :refer [use-mutation]]
            [common.resource.query.social-settings :refer [use-auto-publish]]
            [common.util :refer [spread-obj spread-props format-iso-string]]
            [manage.ad-variant.archive-confirmation-modals
             :refer [use-open-archivation-confirm-modal]]
            [manage.ad-variant.data :as data]
            [manage.ad-variant.queries :as q]
            [manage.adset.hooks :refer [use-synced-with-hogarth? use-auto-approved?]]
            [uix.core :as uix :refer [$ defhook defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui schedule-summary [{:keys [end start timezone]}]
  ($ Typography
     timezone ($ :br)
     (when start (str "From: " (format-iso-string start)))
     (when (and start end) ($ :br))
     (when end (str "To: " (format-iso-string end)))))

(defui scheduling-info-icon [scheduling]
  ($ Tooltip {:title (when (:timezone scheduling) ($ schedule-summary scheduling))}
     ($ SvgIcon {:component Calendar :inheritViewBox true})))

(defn get-status-aggregation-details [status]
  (if (or (string? status) (nil? status))
    {:status status}
    (let [group-statuses (frequencies status)
          first-status-key (key (first group-statuses))]
      (cond
        (= (count group-statuses) 1) {:status first-status-key
                                      :prefix "All "}
        :else {:status (if (contains? group-statuses "approved")
                         "approved"
                         first-status-key)
               :prefix "Partially "
               :aggregation-color "default"}))))

(defui status-chip [{:keys [status chip-props end-icon review?]}]
  (let [{:keys [status aggregation-color prefix]} (get-status-aggregation-details status)
        {:keys [title color]} (get (if review?
                                     data/status-review-mode
                                     data/status-with-qc)
                                   status)
        color (or aggregation-color color "default")]
    ($ Chip
       (spread-props {:label ($ Stack
                                {:direction "row"
                                 :alignItems "center"
                                 :gap 1}
                                (str prefix title)
                                (when end-icon
                                  end-icon))
                      :variant "subtle"
                      :color color
                      :sx (spread-obj #js {:fontWeight 500}
                                      (when (:onClick chip-props)
                                        #js {"&:hover" #js {:filter "brightness(1.1)"
                                                            :backgroundColor (str color ".light")}}))}
                     chip-props))))

(defui approve-menu [{:keys [actions set-approval render-again
                             archive-fn unarchive-fn
                             uuid assigned
                             menu-props horizontal-align close-fn]
                      :or {horizontal-align "left"}}]
  (let [open-archive-confirm (use-open-archivation-confirm-modal)]
    ($ Menu
       (spread-props {:anchorOrigin #js {:horizontal horizontal-align
                                         :vertical "bottom"}
                      :transformOrigin #js {:horizontal horizontal-align
                                            :vertical "top"}
                      :sx #js {:mt 1}}
                     menu-props)
       (when (:cancel-render actions)
         ($ MenuItem
            {:onClick (fn [_e]
                        (render-again {:cancel true
                                       :ad-uuids [uuid]}
                                      #js {:onSettled close-fn}))}
            ($ ListItemText "Cancel render")))
       (when (:render-again actions)
         ($ MenuItem
            {:onClick (fn [_e]
                        (render-again {:ad-uuids [uuid]}
                                      #js {:onSettled close-fn}))}
            ($ ListItemIcon ($ ArrowBounceRight))
            ($ ListItemText "Render again")))
       (when (:approve actions)
         ($ MenuItem
            {:onClick (fn [_e]
                        (set-approval {:approval "approved"
                                       :uuids [uuid]}
                                      #js {:onSettled close-fn}))}
            "Ready"))
       (when (:ready-and-update-dt actions)
         ($ MenuItem
            {:onClick (fn [_e]
                        (set-approval {:approval "ready-and-update-dt"
                                       :uuids [uuid]}
                                      #js {:onSettled close-fn}))}
            "Ready and Update Decision Tree"))
       (when (:internal-review actions)
         ($ MenuItem
            {:onClick (fn [_e]
                        (set-approval {:approval "internal-review"
                                       :uuids [uuid]}
                                      #js {:onSettled close-fn}))}
            "Internal review"))
       (when (:archive actions)
         ($ MenuItem
            {:onClick (fn [_e]
                        (if assigned
                          (open-archive-confirm
                           {:on-confirm (fn [on-success]
                                          (archive-fn {:uuids [uuid]
                                                       :on-success on-success}
                                                      #js {:onSettled close-fn}))})
                          (archive-fn {:uuids [uuid]}
                                      #js {:onSettled close-fn})))}
            "Archive"))
       (when (:unarchive actions)
         ($ MenuItem
            {:onClick (fn [_e]
                        (unarchive-fn {:uuids [uuid]}
                                      #js {:onSettled close-fn}))}
            "Unarchive")))))

(defui ad-variant-type-info [{:keys [sx ad-variant]}]
  ($ Typography {:component "span" :noWrap true :sx sx}
     (data/template-info ad-variant)))

(defn internal-status-icon-text [status]
  (case status
    "approved" {:text "Approved" :icon {:name CheckCircleRoundedIcon
                                        :color "green"}}
    "rejected" {:text "Required Changes" :icon {:name CancelRoundedIcon
                                                :color "red"}}
    {:text "No review"}))

(defui internal-review-tooltip [{:keys [review]}]
  (let [status (internal-status-icon-text (:status/status review))]
    ($ Badge
       (when-let [{icon-name :name :as icon} (:icon status)]
         {:badgeContent ($ icon-name {:sx #js {:color (:color icon)
                                               :borderRadius "50%"
                                               :bgcolor "white"
                                               :fontSize "medium"}})
          :sx #js {"& .MuiBadge-badge" #js {:top "4px"
                                            :right "4px"}}})
       ($ Tooltip {:placement "top"
                   :title ($ :div (str "Reviewer: " (:user-request-mapping/user-name review))
                             ($ :div (str "Status: " (:text status))))}
          ($ Avatar {:sx #js {:width "min-content"
                              :height "min-content"
                              :backgroundColor "white"
                              ".MuiAvatarGroup-root &" #js {:border 0}}}
             ($ AccountCircleRoundedIcon {:color "grey"
                                          :sx #js {:fontSize "xx-large"}}))))))

(defui internal-qc-labels-with-icons [{:keys [review-users]}]
  (let [[max set-max] (uix/use-state 5)]
    ($ AvatarGroup
       {:max max
        :slots #js {:surplus (fn [^js props]
                               ($ Tooltip {:placement "top"
                                           :title "Click to expand"}
                                  ($ Avatar {:sx #js {:fontSize "small"
                                                      :width "28px"
                                                      :height "28px"}
                                             ;; onClick is stolen by the cell in the table
                                             :onMouseDown (fn [^js e]
                                                            (.preventDefault e)
                                                            (.stopPropagation e)
                                                            (set-max (count review-users)))}
                                     (.-children props))))}}
       (for [review review-users]
         ($ internal-review-tooltip {:key (:user-request-mapping/user-id review)
                                     :review review})))))

(defui predictive-score-chip [{:keys [score label]}]
  (if (nil? score)
    ($ Skeleton {:variant "text"
                 :sx      #js {:minWidth "25px"}})
    ($ Chip {:color   (if (>= score 50)
                        "success"
                        "error")
             :variant "subtle"
             :label   (or label
                          (str score "%"))})))

(defhook use-actions [status]
  (let [actions (data/status->actions status)
        auto-approved? (use-auto-approved?)
        auto-publish? (use-auto-publish)
        synced-with-hogarth? (use-synced-with-hogarth?)]
    (cond-> actions
      synced-with-hogarth? (disj :approve)
      auto-publish? (disj :ready-and-update-dt)

      (and (not synced-with-hogarth?) auto-approved?)
      (disj :approve :ready-and-update-dt :internal-review))))

(defui render-status [{:keys [status variant view-mode]}]
  (let [{:keys [uuid assigned]} variant
        {:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
        set-approval-mutation (use-mutation (q/set-approval-mutation {:advertiser-id advertiser-id
                                                                      :adset-id adset-id}))
        render-again-mutation (use-mutation (q/render-again-mutation {:advertiser-id advertiser-id
                                                                      :adset-id adset-id}))
        archive-mutation (use-mutation (q/archive-mutation {:advertiser-id advertiser-id
                                                            :adset-id adset-id}))
        unarchive-mutation (use-mutation (q/unarchive-mutation {:advertiser-id advertiser-id
                                                                :adset-id adset-id}))
        approval-actions-disabled? (use-synced-with-hogarth?)
        popup-state (muips/usePopupState #js {:variant "menu"})
        actions (use-actions status)]
    (if (= view-mode :select)
      (let [{:keys [title]} (get data/status-with-qc status)]
        ($ :<>
           ($ FormControl {:fullWidth true :size "small"}
              ($ InputLabel "Status")
              ($ Select
                 {:value (or status "")
                  :label "Status"
                  :disabled (or approval-actions-disabled? (empty? actions))
                  :open false
                  :onClick (fn [e]
                             (when (seq actions)
                               (let [binding (muips/bindTrigger popup-state)]
                                 ((.-onClick binding) e))))}
                 ($ MenuItem {:value status} title)))
           ($ approve-menu
              {:actions actions
               :menu-props (muips/bindMenu popup-state)
               :horizontal-align "left"
               :uuid uuid
               :assigned assigned
               :set-approval (:mutate set-approval-mutation)
               :render-again (:mutate render-again-mutation)
               :archive-fn (:mutate archive-mutation)
               :unarchive-fn (:mutate unarchive-mutation)
               :close-fn (.-close popup-state)})))
      ($ :<>
         ($ status-chip
            {:status status
             :chip-props (when (seq actions)
                           (let [binding (muips/bindTrigger popup-state)]
                             {:onClick (fn [e]
                                         (.stopPropagation e)
                                         ((.-onClick binding) e))}))
             :end-icon (when (seq actions)
                         ($ SvgIcon
                            {:component ChevronDown}))})
         ($ approve-menu
            {:actions actions
             :menu-props (muips/bindMenu popup-state)
             :horizontal-align "right"
             :uuid uuid
             :assigned assigned
             :set-approval (:mutate set-approval-mutation)
             :render-again (:mutate render-again-mutation)
             :archive-fn (:mutate archive-mutation)
             :unarchive-fn (:mutate unarchive-mutation)
             :close-fn (.-close popup-state)})))))
